import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";
import {TeacherGameSetupService} from "../../../services/teacher-game-setup.service";

@Component({
  selector: 'brt-teacher-time-stop-dialog-footer',
  templateUrl: './teacher-time-stop-dialog-footer.component.html',
  styleUrls: ['./teacher-time-stop-dialog-footer.component.scss']
})
export class TeacherTimeStopDialogFooterComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  constructor(private teacherGameSetupService: TeacherGameSetupService) {
  }
  answerCancel() {
    this.onClosed.emit(true);
  }

  answerAccept() {
    this.teacherGameSetupService.stopGameTimerNoCategories();
    this.onClosed.emit(true);
  }
}
